import { Firestore } from "lib/firebase";
import { useEffect, useState } from "react";
import { datePipe } from "shared/pipes";
import { Ellipsis } from "shared/pipes/ellipsis";

const CustomerCheckoutLogs = ({ customer }) => {
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        const getLogs = async () => {
            const data = await Firestore.collection('users').doc(customer.id)
                .collection('checkout_logs')
                .orderBy('timestamp')
                .get();
            setLogs(data.docs.map((doc) => doc.data()));
        }

        getLogs();
    }, [customer]);

    if (!logs.length) {
        return 'No checkout logs.';
    }

    return (
        <>
            <div className="columns pl-4 is-gapless">
                <div className="column is-1">#</div>
                <div className="column is-2"><b>Action</b></div>
                <div className="column"><b>Data</b></div>
                <div className="column is-2"><b>Time</b></div>
            </div>
            {logs.map((log, index) => (
                <div key={`log-${index}`}
                    className="columns has-background-white p-2 m-2">
                    <div className="column is-1">{index + 1}</div>
                    <div className="column is-2">{log.action}</div>
                    <div className="column">{log.data}</div>
                    <div className="column is-2">
                        <time>
                            <Ellipsis>
                                {datePipe.transform(log.timestamp)}
                            </Ellipsis>
                        </time>
                    </div>
                </div>
            ))}
        </>
    );
}

export { CustomerCheckoutLogs };
